import UsersAssignmentTable from "../UsersSummaryTable/UsersAssignmentTable";

export default function UserAssignment() {

    return (
        <>
            <UsersAssignmentTable />
        </>
    )
}